export default __webpack_public_path__ + "static/banner-mobile-one-82704de2f5ef848ef57bf63d634799e8.jpg";